import { render, staticRenderFns } from "./AssessmentCard.vue?vue&type=template&id=2a4d1398"
import script from "./AssessmentCard.vue?vue&type=script&lang=js"
export * from "./AssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCard.vue?vue&type=style&index=0&id=2a4d1398&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports